import CourseView from "../../components/courses/CourseView";

const AdminCourseDetails = () => {
  return <CourseView />;
};

export default AdminCourseDetails;
